import moment from "moment-timezone";

export function formatDateForApi(d: Date) {
	return moment.utc(d).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
}
